import FeatureSectionSeven, { FeatureSectionSevenProps } from './FeatureSectionSeven'

export default FeatureSectionSeven

export { FeatureSectionSeven }
export type { FeatureSectionSevenProps }
